import { render, staticRenderFns } from "./make-list.vue?vue&type=template&id=46c036e2&scoped=true&"
import script from "./make-list.vue?vue&type=script&lang=js&"
export * from "./make-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c036e2",
  null
  
)

component.options.__file = "make-list.vue"
export default component.exports